<template>
  <form
    class="px-1 md:px-4"
    @submit.prevent
  >
    <!-- 氏名 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_last_name"
      >氏名
        <YaTeCommonBadgeRequired class="ml-4 h-auto py-1 leading-loose" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div class="flex gap-x-4">
          <div class="basis-6/12">
            <input
              id="entry_last_name"
              v-model="lastName"
              class="input w-full border-2 border-co-gray-300"
              placeholder="山田"
              type="text"
              required
            >
            <span
              v-if="errors.last_name && errors.last_name.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.last_name.join(', ') }}
            </span>
          </div>
          <div class="basis-6/12">
            <input
              v-model="firstName"
              class="input w-full border-2 border-co-gray-300"
              placeholder="太郎"
              type="text"
              required
            >
            <span
              v-if="errors.first_name && errors.first_name.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.first_name.join(', ') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- 氏名（カナ） -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_last_name_kana"
      >氏名（カナ）
        <YaTeCommonBadgeRequired class="ml-4 h-auto py-1 leading-loose" />
      </label>
      <div class="basis-full md:basis-8/12">
        <div class="flex gap-x-4">
          <div class="basis-6/12">
            <input
              id="entry_last_name_kana"
              v-model="lastNameKana"
              placeholder="ヤマダ"
              type="text"
              required
              class="input w-full border-2 border-co-gray-300"
            >
            <span
              v-if="errors.last_name_kana && errors.last_name_kana.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.last_name_kana.join(', ') }}
            </span>
          </div>
          <div class="basis-6/12">
            <input
              v-model="firstNameKana"
              placeholder="タロウ"
              type="text"
              required
              class="input w-full border-2 border-co-gray-300"
            >
            <span
              v-if="errors.first_name_kana && errors.first_name_kana.length !== 0"
              class="te-invalid-feedback inline-block"
            >
              {{ errors.first_name_kana.join(', ') }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- メールアドレス -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_email"
      >メールアドレス
        <YaTeCommonBadgeRequired class="ml-4 h-auto py-1 leading-loose" />
      </label>
      <div class="basis-full md:basis-8/12">
        <input
          id="entry_email"
          v-model="email"
          placeholder="taro.yamada@lytechacademy.com"
          type="email"
          required
          class="input w-full border-2 border-co-gray-300"
        >
        <span
          v-if="errors.email && errors.email.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.email.join(', ') }}
        </span>
      </div>
    </div>

    <!-- お問い合わせ内容 -->
    <div class="flex flex-col border-b border-dotted border-co-gray-300 pb-5 pt-4 md:flex-row md:gap-x-8">
      <label
        class="basis-full py-2 font-bold md:basis-4/12 md:text-right"
        for="entry_description"
      >お問い合わせ内容
        <YaTeCommonBadgeRequired class="ml-4 h-auto py-1 leading-loose" />
      </label>
      <div class="basis-full md:basis-8/12">
        <textarea
          id="entry_description"
          v-model="description"
          placeholder="具体的に記述してください"
          class="textarea textarea-bordered h-32 w-full border-2 border-co-gray-300"
        />
        <span
          v-if="errors.description && errors.description.length !== 0"
          class="te-invalid-feedback inline-block"
        >
          {{ errors.description.join(', ') }}
        </span>
      </div>
    </div>

    <!-- 注釈 -->
    <p class="ya-te-note pt-5 text-co-gray-500">
      ※個人情報の取扱い
      <br>
      下記フォームにご記入いただく回答内容は、LINEヤフー株式会社および株式会社ブリューアスがそれぞれ取得します。
      LINEヤフー株式会社は、本フォームに入力いただいたお客さまの情報を<a
        href="https://www.lycorp.co.jp/ja/company/privacypolicy/"
        target="_blank"
      >プライバシーポリシー</a>に定めるところにより、その目的の遂行に必要な範囲において取り扱うこととします。
      株式会社ブリューアスは、本フォームに入力いただいたお客さまのデータを<a
        href="/ly/privacypolicy"
      >プライバシーポリシー</a>に定めるところにより、その目的の遂行に必要な範囲において取り扱うこととします。
    </p>

    <!-- ボタン -->
    <div class="flex flex-col justify-end pt-4 md:flex-row">
      <div class="basis-full md:ml-auto md:basis-8/12 md:pl-6">
        <!-- 送信するボタン -->
        <button
          class="co-btn-submit-stretch ya-te-btn-red"
          @click="onSubmit"
        >
          お問い合わせする
        </button>
        <!-- エラーメッセージ -->
        <span
          v-if="applicationErrors.length !== 0"
          class="te-invalid-feedback inline-block py-2"
        >
          {{ applicationErrors.join(", ") }}
        </span>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { postContact } from '~/utility/fetchAPI'
import validateContactForm from '~/utility/validation/validateContactForm'

const lastName = ref('')
const firstName = ref('')
const lastNameKana = ref('')
const firstNameKana = ref('')
const email = ref('')
const description = ref('')
const errors = ref({})
const applicationErrors = ref([])

const props = defineProps({
  brand: {
    type: String,
    required: true,
  },
})

const { $recaptcha, $api } = useNuxtApp()
useQueryInput(description, 'contact_description')

onMounted(async () => {
  try {
    await $recaptcha.init()
  } catch (e) {
    // 何もしない
  }
})

const onSubmit = async () => {
  const YAHOO_CATEGORY_TYPE = -1
  const token: string = await $recaptcha.execute('registration')
  const body: any = {
    contact: {
      category_type: YAHOO_CATEGORY_TYPE,
      email: email.value,
      last_name: lastName.value,
      last_name_kana: lastNameKana.value,
      first_name: firstName.value,
      first_name_kana: firstNameKana.value,
      description: description.value,
    },
    brand: props.brand,
    recaptcha_token: token,
  }
  validateContactForm(body)
    .then(() => {
      postContact($api, body)
        .then(() => {
          window.location.href = `/yahoo/contact/completed`
        })
        .catch((errors: any) => {
          applicationErrors.value = errors?.response?.data?.errors
        })
    })
    .catch((_errors: any) => {
      errors.value = _errors
    })
}
</script>

<script lang="ts">
import YaTeCommonBadgeRequired from '~/components/YaTe/YaTeCommon/Badge/YaTeCommonBadgeRequired.vue'

const options = {
  components: {
    YaTeCommonBadgeRequired,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
@import url('~/assets/css/YaTe/YaTeCommon/YaTeCommon.css');

.te-invalid-feedback {
  width: 100%;
  margin-top: .25rem;
  font-size: .875em;
  color: #dc3545;
}
</style>
